<template>
    <div v-if="jsonString!=null">
        <div style="font-weight:bolder;color:blue;" v-if="titleField!=null">
            {{title}}
        </div>
        <div style="word-wrap:break-word;">
            {{jsonString}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            jsonString: { type: String, default: null },
            titleField: { type: String, default: null }
        },
        computed: {
            item: function () {
                if (this.jsonString === null) return null;
                return JSON.parse(this.jsonString);
            },
            title: function () {
                if (this.item === null || this.titleField === null) return null;
                return this.item[this.titleField];
            }
        }
    }
</script>